export const LLM_BASE_URL = "/llm"
export const LLM_PROVIDER = "openai" // "openai" | "anthropic"
export const LLM_MODEL = "gpt-5.2"
//export const LLM_PROVIDER = "anthropic" // "openai" | "anthropic"
//export const LLM_MODEL = "claude-sonnet-4-5"
export const LLM_MAX_TOKENS = 1024
export const LLM_FAST_TOOL_RESPONSE = false
export const LLM_STREAMING = true

export const MCP_SERVERS = [
    {
        id: "pp-mcp-remote",
        name: "PP-Plattform-MCP",
        url: "https://pp-mcp.sylphen.com/mcp",
        useLoginMcpToken: true,
        enabled: true
    },
    {
        id: "pp-mcp-local",
        name: "PP-Customer-Server-MCP",
        url: "/mcp",
        useLoginToken: true,
        enabled: true
    }
]

export const MCP_SERVERS_STANDALONE = [
    {
        id: "pp-mcp-remote",
        name: "PP-Plattform-MCP",
        url: "https://pp-mcp.sylphen.com/mcp",
        useStandaloneIpToken: true,
        enabled: true
    }
]

export const DEMO_AUTH_SIGNUP_PATH = "/realtimecrawling/demo/signup"
export const DEMO_AUTH_VERIFY_PATH = "/realtimecrawling/demo/verify"
export const STANDALONE_JWT_STORAGE_KEY = "ppai_standalone_jwt"

export const PPAI_STANDALONE_AUTH_REQUIRED = "PPAI_STANDALONE_AUTH_REQUIRED"
export const PPAI_DEMO_LIMIT_REACHED = "PPAI_DEMO_LIMIT_REACHED"
export const PPAI_DAILY_LIMIT_REACHED = "PPAI_DAILY_LIMIT_REACHED"

export function isStandalone() {
    if (typeof window === "undefined") return false
    return window.location.pathname === "/ppai-standalone" || window.location.pathname.endsWith("/ppai-standalone")
}

export function isInIframe() {
    try {
        return typeof window !== "undefined" && window.self !== window.top
    } catch {
        return true
    }
}

export function getActiveMcpServers() {
    if (isStandalone()) return MCP_SERVERS_STANDALONE.filter((s) => s.enabled)
    return MCP_SERVERS.filter((s) => s.enabled)
}
